import React, { useEffect, useState } from "react";
import { articlesList } from "./ArticlesActions";

const ArticlesHome = (props) => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    async function exibir() {
      const { payload } = articlesList("");
      setArticles((await payload).data.data);
    }
    exibir();
  }, []);

  var articlesSubset = null;

  if (articles && articles.length) {
    articlesSubset = articles.slice(0, props.articlesToShow);
  }

  return (
    <>
      {articlesSubset
        ? articlesSubset.map((article) => {
            return (
              <div className="card mb-3" key={article.article_id}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card-body">
                      <h5 className="card-title">{article.title}</h5>
                      <p className="card-text m-0">
                        <small className="text-muted">{article.year}</small>
                      </p>
                      <p className="card-text m-0">
                        <small className="text-muted">{article.category}</small>
                      </p>
                      <p className="card-text m-0">
                        <small className="text-muted">{article.authors}</small>
                      </p>
                      <p className="card-text m-0">
                        <a
                          className="link link--dia"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={article.access_link}
                        >
                          Acessar a publicação
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </>
  );
};

export default ArticlesHome;
